import { Injectable } from '@angular/core';
import { EntityState, EntityStore, MultiActiveState, StoreConfig } from '@datorama/akita';
import { Acct } from './acct.model';
import { TagsQuery } from '../../../features/new-tags/state/tags.query';
import { dateStringToDate } from './accts.utils';

export interface AcctsState extends EntityState<Acct>, MultiActiveState {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'accts', idKey: 'accountId' })
export class AcctsStore extends EntityStore<AcctsState> {
    constructor(private _tagsQuery: TagsQuery) {
        super();
    }

    /**
     * When accounts are added, make sure if active property is false, status property is set to 'DISABLED'
     * For backwards compatibility.
     */
    akitaPreAddEntity(account: Acct) {
        const fixedAccount = {
            ...account,
            openingTimestamp: dateStringToDate(account.openingDate)?.getTime() || 0,
            closingTimestamp:
                dateStringToDate(account.closingDate)?.getTime() || Date.now()
        };

        // temporary fix for retrieving tags persisted in local storage
        /*const persistedTags = this._tagsQuery.all
            .filter((tag) => {
                return tag.accountIds.includes(account.accountId);
            })
            ?.reduce((acc, tag) => {
                acc[tag.id] = tag.createdDate;
                return acc;
            }, {});

        if (Object.keys(persistedTags).length > 0) {
            fixedAccount.tags = persistedTags;
        }
        if (account?.active === false) {
            fixedAccount.status = AccountStatus.DISABLED;
        }

         */

        return fixedAccount;
    }
}

export const transformAcctToAccount = (acct: Acct) => {
    return {
        name: acct.accountClientAlias || acct.accountIssuerLongName,
        displayName:
            acct.accountDisplayName ||
            acct.accountClientAlias ||
            acct.accountIssuerShortName,
        number: acct.accountNumber || null,
        type: acct.accountType,
        status: acct.status,
        id: acct.accountId,
        issuerId: acct.accountIssuerId,
        currency: acct.currency,
        legalEntityId: acct.ownerId,
        hideIfZeroBalance: acct.hideIfZeroBalance
    };
};
